import CollaborationInvite from './CollaborationInvite';

function App() {
  return <CollaborationInvite />;
}

export default App;
